import {emotionStyled} from '@packages/utilities/styled';

/**
 * @component
 */
export const Spacer = emotionStyled('div')(
  {
    flex: '1 1 0%',
    alignSelf: 'stretch',
    justifySelf: 'stretch',
    minWidth: 0,
  },
  {
    componentName: 'Spacer',
  }
);

Spacer.displayName = 'Spacer';

export default Spacer;
